import { render, staticRenderFns } from "./CornerRightBottom.vue?vue&type=template&id=04c79c27&scoped=true&"
import script from "./CornerRightBottom.vue?vue&type=script&lang=js&"
export * from "./CornerRightBottom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c79c27",
  null
  
)

export default component.exports